/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Button from "../button";

function ImageViewer({ imageUrl, onClose, className, onOpen }) {
  return (
    <div
      className={`z-[9999999999] fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 ${className} ${
        onOpen ? "" : "hidden"
      }`}
    >
      <div className="max-w-md w-full bg-white rounded-lg overflow-hidden shadow-lg p-2">
        <img
          src={imageUrl}
          alt="Image Preview"
          className="mx-auto"
          style={{ height: "50vh" }}
        />
        <div className="p-4 text-center">
          <Button className={"p-2"} onClick={onClose} value={"Close"} />
        </div>
      </div>
    </div>
  );
}

export default ImageViewer;
